
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 3.95a.25.25 0 00-.25.25v1.25h4.5V4.2a.25.25 0 00-.25-.25h-4zm5.75 1.5V4.2A1.75 1.75 0 0014 2.45h-4A1.75 1.75 0 008.25 4.2v1.25H4a.75.75 0 000 1.5h.31l.94 11.284A2.75 2.75 0 008 20.95h8a2.75 2.75 0 002.75-2.716l.94-11.284H20a.75.75 0 000-1.5h-4.25zM15 6.95H5.815l.932 11.188c.002.02.003.041.003.062A1.25 1.25 0 008 19.45h8a1.25 1.25 0 001.25-1.25c0-.02 0-.042.003-.062l.932-11.188H15zm-5 2.5a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75zm4.75.75a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6z"}})])
          )
        }
      }
    